/***
 * PC_FG_01
 * importing the getEmployeeFeedbacks, getDomain api functions
 */
import { useState, useEffect, useRef } from 'react';
import React from 'react';
import { getEmployeeFeedbacks, getDomain, postBulkFeedback, getReportingEmpId } from '../service/DirectorAPI';
import { Feedback } from './Feedback';
import moment from 'moment';
import BreadCrumbs from '../components/BreadCrumbs/BreadCrumbs.jsx';
import '../components/edcss/feedback.css';
import '../components/edcss/profile.css';
import '../components/edcss/Team-DirectoryGrid.css';
import Loader from '../StaticComponent/Loader';
import { encryptStorage } from '../constant';
import { read, utils, writeFile } from 'xlsx';
import { NotificationTrigger } from '../utils/RegHandling';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { useNavigate } from 'react-router-dom';
import { getS3 } from '../utils/Download.js';
/**
 * PC_FG_03 create a FeedbackGrid()) function and it return the HTML
 *
 */
export function FeedbackGrid(props) {
    /***
     * PC_FG_02
     * declaring the state variables
     */

    let FeedbackGridarray = [];
    const [feedbackGridData, setFeedbackGridData] = useState(FeedbackGridarray);
    let dropDownArraydomain = [];
    const [arrDropDowndomain, setarrDropDowndomain] = useState(dropDownArraydomain);
    const [searchValue, setSearchValue] = useState('');
    const [columnOrder, setColumnOrder] = useState('DESC');
    const [columnName, setColumnName] = useState('modified_at');
    const [sorthide, setsorthide] = useState('modified_at@DESC');
    const [dataLength, setdataLength] = useState(0);
    let login_id = encryptStorage.getItem('employeeId');
    let role = encryptStorage.getItem('role');
    const [hideFilterPopUp, sethideFilterPopUp] = useState(true);
    const [countPerPage, setCoutPerPage] = useState(10);
    const [isLoading, setIsLoading] = useState(true);
    const [importPopup, setImportPopup] = useState(false);
    const [validationImport, setValidationImport] = useState('');
    const [fileName, setFileName] = useState('');
    const [file, setFile] = useState();
    let CurrentEvaluationId = encryptStorage.getItem('CurrentEvaluationId');

    let filter = {
        flags: '',
        domain: '',
        status: '',
        startDate: '',
        endDate: '',
    };
    let [filterData, setFilterData] = useState(filter);

    let breadCrumbsData =
        role == 'Admin'
            ? [
                { title: 'Dashboard', isActive: true, path: '/Overview' },
                { title: 'Admin', isActive: true, path: '/admin' },
                { title: 'Team Member', isActive: true, path: '' },
                { title: 'Feedback', isActive: false, path: '/FeedbackGrid' },
            ]
            : [
                { title: 'Dashboard', isActive: true, path: '/Overview' },
                { title: 'Team Member', isActive: true, path: '' },
                { title: 'Feedback', isActive: false, path: '/FeedbackGrid' },
            ];

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let response = params.get('response');
    let evid = params.get('evaluationid');
    const attachment = useRef(null);

    /***
     * PC_FG_03
     * UseEffect call the loadFeedbackGridPage and loadDomain function
     */
    let emp_id = params.get('EmpId');
    const navigate = useNavigate('');

    useEffect(() => {
        loadFeedbackGridPage();
        LoadDomain();
    }, [countPerPage, columnOrder, columnName]);

    /**
     * PC_FG_03.1
     * loadFeedbackGridPage get the data fron database based on payload
     */
    const loadFeedbackGridPage = async (filter = {}) => {
        let search = window.location.search;
        let params = new URLSearchParams(search);

        let login_id = encryptStorage.getItem('employeeId');
        let role = encryptStorage.getItem('role');
        sethideFilterPopUp(true);
        setIsLoading(false);

        if (filter?.flags === undefined) {
            filter = filterData;
        }

        try {
            let empdata = {
                id: '',
                emp_response: '',
                evaluation_id: '',
                emp_id: emp_id,
                searchColumnName: 'emp_name',
                role: role,
                searchData: searchValue,
                sortOrder: columnOrder,
                sortColumn: columnName,
                PageSize: countPerPage,
                emp_response: filter.status || response || '',
                flags: filter.flags,
                domain: filter.domain,
                startDate: filter.startDate,
                endDate: filter.endDate,
                evaluationid: evid,
            };
            let validReportTo = false;
            
        switch (encryptStorage.getItem('groupid')) {
            case '1': {
                validReportTo = true;
                break;
            }
            case '2': {

                if (encryptStorage.getItem('employeeId') == emp_id) {
                    validReportTo = true;
                } else {
                    let request = {
                        login_id: encryptStorage.getItem('employeeId'),
                    };
                    let respdata = await getReportingEmpId(request);

                        for (let i = 0; i < respdata.data.ResponseData[0]?.length; i++) {
                            if (respdata.data.ResponseData[0][i]?.emp_id === emp_id) {
                                validReportTo = true;
                            }
                            //
                        }
                    }
                    break;
                }
                case '3':
                    {
                        if (emp_id == encryptStorage.getItem('employeeId'))
                            validReportTo = true;
                        break
                    }
                default: {
                    navigate('*');
                    break;
                }
            }
            if (validReportTo) {
                let data = await getEmployeeFeedbacks(empdata);

                //if (data.data != undefined && data.data != null && data.data.ResponseData[0].length != 0) {
                setFeedbackGridData(data.data.ResponseData[0]);
                setdataLength(data.data.ResponseData[1]);
                //}
                if (data.data.status == 200) {
                    setIsLoading(true);
                }
            } else {
                navigate('/', { state: { hideNav: false } });
            }
        } catch (e) { }
    };
    function removeHTMLTags(input) {
        if (!input) return '';
        
        // Remove all HTML tags
        let text = input.replace(/<[^>]*>/g, '');
        
        // Decode HTML entities
        let textarea = document.createElement('textarea');
        textarea.innerHTML = text;
        text = textarea.value;
        
        // Trim whitespace and remove extra spaces
        return text.trim().replace(/\s+/g, ' ');
    }

    /***
     * PC_FG_10
     * this function map and return the value
     */

    const feedbackGridBodyData = () => {
        try {
            if (feedbackGridData.length == 0) {
                return (
                    <tr>
                        <td colspan="10" className="accord-content1">
                            <div className="row justify-content-center">
                                <img
                                    src="/Images/nodatafound.png"
                                    alt="nodatafound"
                                    className="nofeedbackimg-sty"
                                    style={{ height: '500px', width: '750px' }}
                                />
                                <h2 className="tt-bold font-15 text-center margin-negative">No Feedbacks Found</h2>
                            </div>
                        </td>
                    </tr>
                );
            } else {
                return feedbackGridData.map((obj, index) => {
                    let m = moment(new Date(obj.modified_at));
                    let FeeabackDate = m.format('MMM DD, YYYY');

                    var tipCount;
                    var commentsBind;
                    if (removeHTMLTags(obj.comments).length > 15) {
                            commentsBind = removeHTMLTags(obj.comments).substring(0, 15) + '...';
                            tipCount = 1;
                    } else {
                            commentsBind = removeHTMLTags(obj.comments);
                            tipCount = 0;
                    }

                    return (
                        <tr className="hive-table-data regular-text">
                            <div className="d-flex align-items-center">
                                <img src="/Images/logo-person-user-person-icon.jpg" className="table-image" />
                                <div className="ms-2">
                                    <a className="directory-name-style mb-0">{obj.emp_name}</a>
                                    <p className="directory-domain-style mb-0">{obj.role}</p>
                                </div>
                            </div>
                            {role == 'Hr Manager' || role == 'Hr' ? <td>{obj.domain}</td> : null}
                            <td>{FeeabackDate}</td>

                            {obj.flags == 'G' ? (
                                <td className="text-center">
                                    <img
                                        src="/Images/profile-feedback-green.svg"
                                        className="profile-feedback-flag-size"
                                        alt="Flag Icon Green"
                                    />
                                </td>
                            ) : null}
                            {obj.flags == 'Y' ? (
                                <td className="text-center">
                                    <img
                                        src="/Images/profile-feedback-yellow.svg"
                                        className="profile-feedback-flag-size"
                                        alt="Flag Icon Yellow"
                                    />
                                </td>
                            ) : null}
                            {obj.flags == 'R' ? (
                                <td className="text-center">
                                    <img
                                        src="/Images/profile-feedback-red.svg"
                                        className="profile-feedback-flag-size"
                                        alt="Flag Icon Red"
                                    />
                                </td>
                            ) : null}
                            {obj.flags == null || obj.flags == undefined ? (
                                <td className="text-center">
                                    <span>-</span>
                                </td>
                            ) : null}

                            <td>{obj.feedbacked_by}</td>
                            <td>{obj.comments_based_on}</td>
                            <td>
                                <a
                                    className={tipCount == 0 ? 'tooltip-color tooltipCursor' : 'tooltip-color'}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title={tipCount == 1 ? removeHTMLTags(obj.comments) : ''}
                                >
                                  {removeHTMLTags(commentsBind)}
                                </a>
                            </td>

                            {obj.emp_response == 'Agreed' ? (
                                <td className="text-center">
                                    <span className="status-btn bg-pastel-green">{obj.emp_response}</span>
                                </td>
                            ) : null}
                            {obj.emp_response == 'Pending' || obj.emp_response == 'pending' ? (
                                <td className="text-center">
                                    <span className="status-btn bg-pastel-orange">{obj.emp_response}</span>
                                </td>
                            ) : null}
                            {obj.emp_response == 'Disagree' ? (
                                <td className="text-center">
                                    <span className="status-btn bg-pastel-red">{obj.emp_response}</span>
                                </td>
                            ) : null}
                            {/* PC_FG_11 this view button redirect to the Feedback.jsx component */}
                            <td className="text-center">
                                <a
                                    href={`/Feedback?EmpId=${obj.emp_id}&FeedbackId=${obj.id}&EvaluationId=${obj.evaluation_id}&IsMainGrid=true`}
                                    className="text-decoration-none"
                                >
                                    View
                                </a>
                            </td>
                        </tr>
                    );
                });
            }
        } catch (e) { }
    };
    /***
     * PC_FG_03.2
     * this function invock the getDomain api call
     */
    const LoadDomain = async () => {
        let domainData = {};
        let responsedata = await getDomain(domainData);

        setarrDropDowndomain(responsedata.data.ResponseData[0]);
    };
    /***
     * PC_FG_03.3
     * this function map and return the value
     */

    const buildDomain = () => {
        return arrDropDowndomain.map((value, index) => {
            return <option value={value.domain}>{value.domain}</option>;
        });
    };

    /***
     * PC_FG_22
     * this function set the column name and sort order into the object
     * and invoke the useEffect because the variables are passed into the uesEffect dependency
     */

    const sortClicked = (e) => {
        try {
            let sortID = e.target.id;
            let sortval = sortID.split('@');
            setColumnName(sortval[0]);
            setColumnOrder(sortval[1]);
            setsorthide(sortID);
            //setSearchValue("");
            //loadFeedbackGridPage();
        } catch (e) { }
    };

    /**
     * PC_FG_13
     * handelsearch function set the value into the searchvalue statevariable
     * and call the loadFeedbackGridPage() through useeffect function to get the data
     */

    const handleSearch = (e) => {
        try {
            setSearchValue(e.target.value);
        } catch (e) { }
    };

    /**
     * PC_FG_13
     * handelSearchKeyDowm function call the loadFeedbackGridPage while user click enter
     */

    const handleSearchKeyDown = (e) => {
        if (e.charCode == 13) {
            //setColumnName("");
            loadFeedbackGridPage();
        }
    };

    /**
     * PC_FG_13
     * search click function call the loadFeedbackGridPage when user clicks the search icon
     */
    const searchClick = () => {
        //setColumnName("");
        loadFeedbackGridPage();
    };
    const OnChangeName = (e) => {
        if (e.target.value == 'Select') {
            setFilterData({ ...filterData, [e.target.name]: '' });
        } else {
            setFilterData({ ...filterData, [e.target.name]: e.target.value });
        }
    };

    /***
     * PC_FG_31
     * this function show and hide the filter popup
     */
    const filterClicked = async () => {
        try {
            sethideFilterPopUp(hideFilterPopUp == true ? false : true);
        } catch (e) { }
    };

    /***
     * PC_FG_31
     * this function clear the all filter values and call the loadFeedbackGridPage function
     */

    const filterClearClicked = () => {
        let filter = {
            flags: '',
            domain: '',
            status: '',
            startDate: '',
            endData: '',
        };
        filterClicked();
        setFilterData(filter);
        loadFeedbackGridPage(filter);
    };

    /***
     * PC_FG_13 this function increment the page count base on click
     */

    const handleLoadMore = () => {
        try {
            // setSearchValue("");
            // setColumnName("");
            setCoutPerPage(countPerPage + 10);
            //loadFeedbackGridPage();
        } catch (e) { }
    };

    //PF_01 this function is used to show the import multiple feedback popup when click the Import Feedback button.
    const importFeedback = async () => {
        try {
            setImportPopup(true);
        } catch (e) {
            throw e;
        }
    };
    //PF_02 this function is used to hide the import multiple feedback popup when click the X or cancel button in Import Multiple Feedback.
    const cancelImportFeedback = async () => {
        try {
            setImportPopup(false);
            setValidationImport('');
            setFileName('');
            attachment.current.value = null;
        } catch (e) {
            throw e;
        }
    };
    //PF_03 this function is used to download the template for import feedback of multiple users .
    // const downloadTemplate = async () => {
    //     try {
    //         let val=getS3('https://ava-hive-np-img-s3.s3.us-east-2.amazonaws.com/Import-Feedback.xlsm')
    //         window.open(val);
    //     } catch (e) {
    //         throw e;
    //     }
    // };
    //PF_18 This function is used to export the feedback of the employee in Excel format
    const handleExportFeedback = async () => {
        //let lastindex = HierArchyID.length - 1;
        setIsLoading(false);
        try {
            let search = window.location.search;
            let params = new URLSearchParams(search);
            let empid = params.get('EmpId');
            //
            // const withoutLineBreaks = empid.replace(/\s/g, '+');
            //
            // let emp_id = encryptStorage.decryptValue(`${withoutLineBreaks}`);
            let filter = filterData;
            let empdata = {
                id: '',
                emp_response: '',
                evaluation_id: '',
                emp_id: empid,
                searchColumnName: 'emp_name',
                role: role,
                searchData: searchValue,
                sortOrder: columnOrder,
                sortColumn: columnName,
                PageSize: null,
                emp_response: filter.status || response || '',
                flags: filter.flags,
                domain: filter.domain,
                startDate: filter.startDate,
                endDate: filter.endDate,
                evaluationid: evid,
            };
            let responses = await getEmployeeFeedbacks(empdata);
            let user = responses.data.ResponseData[0];
            let exportToExcel = [
                ['Team Members Name', 'Domain', 'Flags', 'Feedbacks by', 'Feedbacks Based On', 'Comments', 'Employee Response', 'Date'],
            ];

            for (var i = 0; i < user.length; i++) {
                let flags;
                if (user[i].flags == 'G') {
                    flags = 'Green';
                } else if (user[i].flags == 'Y') {
                    flags = 'Yellow';
                } else if (user[i].flags == 'R') {
                    flags = 'Red';
                }
                let val = [];
                val.push(
                    user[i].emp_name,
                    user[i].domain,
                    flags,
                    user[i].feedbacked_by,
                    user[i].comments_based_on,
                    removeHTMLTags(user[i].comments),
                    user[i].emp_response,
                    moment(user[i].created_at).utc().format('MM-DD-YYYY')
                );
                exportToExcel.push(val);
            }
            let filename =
                'FeedBack Report' +
                new Date().getFullYear() +
                '' +
                new Date().getMonth() +
                '' +
                new Date().getDate() +
                '' +
                new Date().getHours() +
                '' +
                new Date().getMinutes() +
                '' +
                new Date().getSeconds();
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const fileExtension = '.xlsx';
            let ws = XLSX.utils.aoa_to_sheet(exportToExcel);
            // const exportToCSV = (csvData, fileName) => {
            // const ws = XLSX.utils.(csvData);
            const wb = { Sheets: { 'View Log': ws }, SheetNames: ['View Log'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data1 = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data1, filename + fileExtension);
            setIsLoading(true);
        } catch (error) {
            throw error;
        }
    };
    //onchange method for upload the file in Import Feedback popup
    const uploadFile = async (e) => {
        try {
            
            let result = true;
            const typeArr = ['vnd.ms-excel.sheet.macroEnabled.12'];
            // let type = typeArr.includes(e.target.files[0].type.split('.')[1]);
            let type = typeArr.includes(e.target.files[0].type.split('/')[1]);
            if (type == false) {
                setValidationImport('The uploaded file should be in xlsm format');
                attachment.current.value = '';
                result = false;
            } else {
                setValidationImport('');
                setFileName(e.target.files[0].name);
                setFile(e);
            }
        } catch (e) {
            throw e;
        }
    };
    //This method is invoked when user click the x icon near uploaded File Name
    let cancel = () => {
        setFileName('');
        attachment.current.value = null;
    };
    //PF_05 this function is used to save the feedback of the Employee
    const saveFeedback = async () => {
        try {

            if (file == undefined || file == null || file == '') {
                setValidationImport('Please upload File');
                attachment.current.value = '';
            } else {
                const files = file.target.files;
                const typeArr = ['vnd.ms-excel.sheet.macroEnabled.12'];
                // let type = typeArr.includes(e.target.files[0].type.split('.')[1]);
                let type = typeArr.includes(file.target.files[0].type.split('/')[1]);
                if (type == false) {
                    setValidationImport('The uploaded file should be in xlsm format');
                    attachment.current.value = '';
                } else {
                    setValidationImport('');
                    if (files.length) {
                        setIsLoading(false);
                        setImportPopup(false);
                        const file = files[0];
                        const reader = new FileReader();
                        reader.onload = async (event) => {
                            const wb = read(event.target.result);
                            const sheets = wb.SheetNames;
                            if (sheets.length) {
                                const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
                                if (rows.length > 0) {
                                    let checkArray = [
                                        'Employee ID',
                                        'Feedback Given by(Employee ID)',
                                        'Role',
                                        'Flag',
                                        'Comments',
                                        'Comments based on',
                                    ];
                                    let keys = Object.keys(rows[0]);

                                    if (JSON.stringify(checkArray) === JSON.stringify(keys)) {
                                        const newArrayOfObj = rows.map(
                                            ({
                                                'Employee ID': emp_id,
                                                'Feedback Given by(Employee ID)': login_emp_id,
                                                Role: feedback_by_role,
                                                Flag: flags,
                                                Comments: comments,
                                                'Comments based on': comments_based_on,
                                                ...rest
                                            }) => ({
                                                emp_id,
                                                login_emp_id,
                                                feedback_by_role,
                                                flags,
                                                comments,
                                                comments_based_on,
                                                ...rest,
                                            })
                                        );

                                        const finalArray = newArrayOfObj.map((v) => ({
                                            ...v,
                                            evaluation_id: CurrentEvaluationId,
                                            emp_response: 'Pending',
                                            LoginRole: role,
                                        }));
                                        let responsedata = await postBulkFeedback(finalArray);

                                        if (responsedata.data.status == 200 && responsedata.data.resource == true) {
                                            let feedbackId = responsedata.data.ResponseData[0];
                                            let empid = responsedata.data.ResponseData[1];
                                            let feedback_empid = responsedata.data.ResponseData[2];
                                            for (let i = 0; i < responsedata.data.ResponseData[0].length; i++) {
                                                let employeeId = (empid[i]);
                                                await NotificationTrigger(
                                                    {
                                                        title: 'Feedback',
                                                        message: 'Feedback raised against you',
                                                        route: `/Feedback?EmpId=${empid[i]}&FeedbackId=${feedbackId[i].id}&EvaluationId=${CurrentEvaluationId}&IsProfile=true&IsTeamMember=true`,
                                                        state: {},
                                                        to_employee: [empid[i]],
                                                        by: feedback_empid[i],
                                                    },
                                                    empid[i],
                                                    props.websocket
                                                );
                                            }
                                            cancelImportFeedback();
                                            setIsLoading(true);
                                        } else {
                                            setImportPopup(true);
                                            if (role == 'Manager' && responsedata.data.resource == false) {
                                                setValidationImport('Please upload Feedback only for your resources');
                                            } else {
                                                setValidationImport('Please upload Valid Inputs');
                                            }

                                            setFileName('');
                                            setIsLoading(true);
                                        }
                                    } else {
                                        setImportPopup(true);
                                        setValidationImport('Please upload Valid Excel File');
                                        // attachment.current.value = '';
                                        setFileName('');
                                        setIsLoading(true);
                                    }
                                }
                            }
                        };
                        setIsLoading(true);
                        reader.readAsArrayBuffer(file);
                    }
                }
            }
        } catch (e) {
            throw e;
        }
    };

    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="container-fluid mt-5">
                <div className="row justify-content-center body-bg ">
                    {/*Tab Structure Starts Here*/}

                    <div className="col-md-11 mt-2" style={{ marginTop: '10px' }}>
                        <BreadCrumbs data={breadCrumbsData} />
                    </div>

                    <div className="col-md-11 d-flex justify-content-between my-4  align-items-center">
                        <label className="tt-bold font-15 ">Feedback</label>
                        <div className="ms-auto d-flex">
                            <div className="input-group flex-nowrap search-group me-2">
                                <input
                                    type="search"
                                    className="form-control search-align "
                                    placeholder="Search by Team Member"
                                    aria-label="Username"
                                    aria-describedby="addon-wrapping"
                                    onKeyPress={(e) => handleSearchKeyDown(e)}
                                    onChange={(e) => handleSearch(e)}
                                />
                                <button
                                    className="input-group-text btn btn-search-custom "
                                    id="addon-wrapping"
                                    name="emp_name@Desc"
                                    onClick={() => searchClick()}
                                >
                                    <img src="/Images/search-icon.svg" alt="search-icon" />
                                </button>
                            </div>

                            {/*Filter Section Starts Here*/}
                            <div className="dropdown">
                                <button
                                    className="advanced-filter-button me2 medium-text"
                                    type="button"
                                    id="feedback-filter-dropdown"
                                    data-bs-toggle="dropdown"
                                    onClick={() => filterClicked()}
                                >
                                    <img src="/Images/filter-icon.svg" className="me-2" />
                                    Filter
                                </button>

                                {!hideFilterPopUp ? (
                                    <div
                                        className="dropdown-menu px-3 advanced-filter-panel feedback-grid-filter"
                                        style={{ display: 'block' }}
                                    >
                                        <div className="row">
                                            <div className="col-md-12 py-2 border-0 mb-1">
                                                <span className="font-14 semibold-text advanced-filter-title">Advanced Filter</span>
                                                <button
                                                    type="button"
                                                    className="btn-close float-end close-filter"
                                                    data-bs-dismiss="advanced-filter"
                                                    aria-label="Close"
                                                    onClick={() => filterClicked()}
                                                />
                                            </div>
                                            <div className="col-md-12 ">
                                                <div className="row mb-3">
                                                    <div className="col-md-6 mb-3 ">
                                                        <label className="form-label hive-form-label" htmlFor="approval-status">
                                                            Response
                                                        </label>
                                                        <select
                                                            className="form-select hive-form-control"
                                                            id="approval-status"
                                                            name="status"
                                                            value={filterData.status}
                                                            onChange={(e) => {
                                                                OnChangeName(e);
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="Agreed">Agreed</option>
                                                            <option value="Disagree">Disagree</option>
                                                            <option value="Pending">Pending</option>
                                                        </select>
                                                    </div>

                                                    {role == 'Hr Manager' || role == 'Hr' ? (
                                                        <div className="col-md-6 mb-3 ">
                                                            <label className="form-label hive-form-label" htmlFor="approval-status">
                                                                Domain
                                                            </label>
                                                            <select
                                                                className="form-select hive-form-control"
                                                                id="approval-status"
                                                                name="domain"
                                                                value={filterData.domain}
                                                                onChange={(e) => {
                                                                    OnChangeName(e);
                                                                }}
                                                            >
                                                                <option value="">Select</option>
                                                                {buildDomain()}
                                                                {/* PC_FG_10 buildDomain function bind the domain dropdown data */}
                                                            </select>
                                                        </div>
                                                    ) : null}

                                                    <div className="col-md-6 mb-3 ">
                                                        <label className="form-label hive-form-label" htmlFor="approval-status">
                                                            Flags
                                                        </label>
                                                        <select
                                                            className="form-select hive-form-control"
                                                            id="approval-status"
                                                            name="flags"
                                                            value={filterData.flags}
                                                            onChange={(e) => {
                                                                OnChangeName(e);
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="G">Green</option>
                                                            <option value="Y">Yellow</option>
                                                            <option value="R">Red</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 pb-2 border-0 ">
                                                    <span className="font-14 semibold-text filter-title">Date Range</span>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label hive-form-label" htmlFor="fromrange">
                                                            From
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className="form-control hive-form-control"
                                                            id="fromrange"
                                                            name="startDate"
                                                            value={filterData.startDate}
                                                            max={filterData.endDate}
                                                            onChange={(e) => {
                                                                OnChangeName(e);
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label hive-form-label" htmlFor="torange">
                                                            To
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className="form-control hive-form-control"
                                                            id="torange"
                                                            name="endDate"
                                                            value={filterData.endDate}
                                                            min={filterData.startDate}
                                                            onChange={(e) => {
                                                                OnChangeName(e);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12 my-3 d-flex justify-content-end">
                                                <button className="btn hive-btn-secondary" onClick={() => filterClearClicked()}>
                                                    Clear
                                                </button>
                                                <button className="btn hive-btn-primary" onClick={() => loadFeedbackGridPage()}>
                                                    Apply
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            {/*Filter Section Ends Here*/}
                            <button
                                className="btn hive-btn-outline me-3 mx-2"
                                onClick={() => {
                                    handleExportFeedback();
                                }}
                            >
                                Export Feedback
                            </button>
                            <div className="dropdown">
                                <button
                                    className="btn hive-btn-primary"
                                    onClick={() => {
                                        importFeedback();
                                    }}
                                >
                                    Import Feedback
                                </button>
                                {importPopup ? (
                                    <div className="mb-3 col-md-3">
                                        <div
                                            className="modal fade show"
                                            style={{ display: 'block' }}
                                            id="MyPopup"
                                            tabIndex={-1}
                                            aria-labelledby="exampleModalLabel"
                                            aria-hidden="true"
                                        >
                                            <div className="modal-dialog feedback-popup modal-dialog-centered border-0 ">
                                                <div className="modal-content">
                                                    <div className="modal-header border-0">
                                                        <h5
                                                            className="modal-title font-18 semibold-text feedback-head-clr"
                                                            id="exampleModalLabel"
                                                        >
                                                            Import Multiple Feedbacks
                                                        </h5>
                                                        <button
                                                            type="button"
                                                            className="btn-close"
                                                            data-bs-dismiss="modal"
                                                            aria-label="Close"
                                                            onClick={() => {
                                                                cancelImportFeedback();
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="modal-body pt-2 pb-1">
                                                        <div className="row mb-4">
                                                            <div className="col-md-12">
                                                                <label className="medium-text w-100 mb-3">
                                                                    Use the template to add multiple feedbacks
                                                                </label>
                                                                <a
                                                                    href="#"
                                                                    className="anchor-text font-15 text-decoration-none"
                                                                    style={{cursor:"pointer"}} onClick={async () => {

                                                                        window.open(await getS3('https://ava-hive-np-img-s3.s3.us-east-2.amazonaws.com/Import-Feedback.xlsm'), "_blank");
                                
                                
                                                                    }} 
                                                                    // onClick={() => {
                                                                    //     downloadTemplate();
                                                                    // }}
                                                                >
                                                                    <img src="Images/excel.svg" alt="text" /> Download Template
                                                                </a>
                                                                <span>
                                                                    <img
                                                                        src="Images/info-icon.svg"
                                                                        alt="info-icon"
                                                                        className="ms-2"
                                                                        title="To edit the download template,You need to unblock the security checkbox in the General tab of the Properties for the file"
                                                                    />
                                                                </span>
                                                            </div>
                                                            <div className="mt-4">
                                                                <label htmlFor="voterid-upload" className="custom-file-upload-styles">
                                                                    <img className="me-2" src="Images/top-up.svg" alt="Upload Icon" />
                                                                    Import
                                                                </label>
                                                                <input
                                                                    id="voterid-upload"
                                                                    className="custom-file-upload-btn"
                                                                    type="file"
                                                                    ref={attachment}
                                                                    onChange={uploadFile}
                                                                />
                                                                <div>
                                                                    {fileName} {/* {validationImport} */}
                                                                    {validationImport ? (
                                                                        <label className=" hive-form-label w-100 hive-form-mandatory">
                                                                            {validationImport}
                                                                        </label>
                                                                    ) : null}
                                                                    {fileName !== '' && fileName !== undefined && fileName !== null ? (
                                                                        <img
                                                                            src="/Images/profile-certificate-cancel.svg"
                                                                            alt=""
                                                                            onClick={() => {
                                                                                cancel();
                                                                            }}
                                                                        />
                                                                    ) : null}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12 justify-content-end d-flex">
                                                                <button
                                                                    className="btn hive-btn-secondary me-3"
                                                                    onClick={() => {
                                                                        cancelImportFeedback();
                                                                    }}
                                                                >
                                                                    Cancel
                                                                </button>
                                                                <button
                                                                    className="btn hive-btn-primary"
                                                                    onClick={(e) => {
                                                                        saveFeedback(e);
                                                                    }}
                                                                >
                                                                    Save
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                    </div>
                    {/*Tab Content Starts Here*/}

                    <div className="col-md-11">
                        {/* <div className="table-responsive"> */}
                        <div className='table-responsive'>
                            <table className="table bg-white hive-grid table-borderless profile-regular-font">
                                <thead>
                                    <tr>
                                        <th className="hive-table-head bold-text font-14">
                                            Team Member
                                            <span className="ps-2">
                                                <img
                                                    src="/Images/Sort-up.svg"
                                                    className="hive-table-sort"
                                                    id="emp_name@ASC"
                                                    onClick={(e) => sortClicked(e)}
                                                    hidden={sorthide == 'emp_name@ASC' ? true : false}
                                                />
                                                <img
                                                    src="/Images/sort-icon.svg"
                                                    className="hive-table-sort"
                                                    id="emp_name@DESC"
                                                    onClick={(e) => sortClicked(e)}
                                                    hidden={sorthide == 'emp_name@ASC' ? false : true}
                                                />
                                            </span>
                                        </th>
                                        {role == 'Hr Manager' || role == 'Hr' ? (
                                            <th className="hive-table-head bold-text font-14">
                                                Domain
                                                <span className="ps-2">
                                                    <img
                                                        src="/Images/Sort-up.svg"
                                                        className="hive-table-sort"
                                                        id="domain@ASC"
                                                        onClick={(e) => sortClicked(e)}
                                                        hidden={sorthide == 'domain@ASC' ? true : false}
                                                    />
                                                    <img
                                                        src="/Images/sort-icon.svg"
                                                        className="hive-table-sort"
                                                        id="domain@DESC"
                                                        onClick={(e) => sortClicked(e)}
                                                        hidden={sorthide == 'domain@ASC' ? false : true}
                                                    />
                                                </span>
                                            </th>
                                        ) : null}

                                        <th className="hive-table-head bold-text font-14">
                                            Date
                                            <span className="ps-2">
                                                <img
                                                    src="/Images/Sort-up.svg"
                                                    className="hive-table-sort"
                                                    id="modified_at@ASC"
                                                    onClick={(e) => sortClicked(e)}
                                                    hidden={sorthide == 'modified_at@ASC' ? true : false}
                                                />
                                                <img
                                                    src="/Images/sort-icon.svg"
                                                    className="hive-table-sort"
                                                    id="modified_at@DESC"
                                                    onClick={(e) => sortClicked(e)}
                                                    hidden={sorthide == 'modified_at@ASC' ? false : true}
                                                />
                                            </span>
                                        </th>
                                        <th className="hive-table-head text-center bold-text font-14">Flags</th>
                                        <th className="hive-table-head bold-text font-14">
                                            Feedbacks By
                                            <span className="ps-2">
                                                <img
                                                    src="/Images/Sort-up.svg"
                                                    className="hive-table-sort"
                                                    id="created_by@ASC"
                                                    onClick={(e) => sortClicked(e)}
                                                    hidden={sorthide == 'created_by@ASC' ? true : false}
                                                />
                                                <img
                                                    src="/Images/sort-icon.svg"
                                                    className="hive-table-sort"
                                                    id="created_by@DESC"
                                                    onClick={(e) => sortClicked(e)}
                                                    hidden={sorthide == 'created_by@ASC' ? false : true}
                                                />
                                            </span>
                                        </th>

                                        <th className="hive-table-head bold-text font-14">
                                            Feedbacks
                                            <span className="ps-2">
                                                <img
                                                    src="/Images/Sort-up.svg"
                                                    className="hive-table-sort"
                                                    id="comments_based_on@ASC"
                                                    onClick={(e) => sortClicked(e)}
                                                    hidden={sorthide == 'comments_based_on@ASC' ? true : false}
                                                />
                                                <img
                                                    src="/Images/sort-icon.svg"
                                                    className="hive-table-sort"
                                                    id="comments_based_on@DESC"
                                                    onClick={(e) => sortClicked(e)}
                                                    hidden={sorthide == 'comments_based_on@ASC' ? false : true}
                                                />
                                            </span>
                                        </th>

                                        <th className="hive-table-head bold-text font-14">Comments</th>
                                        <th className="hive-table-head text-center bold-text font-14">
                                            Response
                                            <span className="ps-2">
                                                <img
                                                    src="/Images/Sort-up.svg"
                                                    className="hive-table-sort"
                                                    id="emp_response@ASC"
                                                    onClick={(e) => sortClicked(e)}
                                                    hidden={sorthide == 'emp_response@ASC' ? true : false}
                                                />
                                                <img
                                                    src="/Images/sort-icon.svg"
                                                    className="hive-table-sort"
                                                    id="emp_response@DESC"
                                                    onClick={(e) => sortClicked(e)}
                                                    hidden={sorthide == 'emp_response@ASC' ? false : true}
                                                />
                                            </span>
                                        </th>
                                        <th className="hive-table-head text-center bold-text font-14">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* PC_FG_10 feedbackGridBodyData function bind the grid data */}
                                    {feedbackGridBodyData()}
                                </tbody>
                            </table>
                        </div>
                        {/* </div> */}
                        <div className="text-center">
                            {dataLength > countPerPage ? (
                                <button className="btn bg-white font-14 medium-text mb-3" onClick={() => handleLoadMore()}>
                                    Show More
                                </button>
                            ) : null}
                        </div>
                    </div>

                    {/*All Leave Request Section Ends Here*/}
                    {/*My Leave Request Section Starts Here*/}
                    <div
                        className="tab-pane fade show active"
                        id="my_leave_request"
                        role="tabpanel"
                        aria-labelledby="my_leave_request_tab"
                    ></div>
                    {/*My Leave Request Section Ends Here*/}
                    {/*WFH Request Section Starts Here*/}
                    <div className="tab-pane fade show active" id="wfh_request" role="tabpanel" aria-labelledby="wfh_request_tab"></div>
                    {/*WFH Request Section Ends Here*/}
                    {/*My WFH Request Section Starts Here*/}
                    <div
                        className="tab-pane fade show active"
                        id="my_wfh_request"
                        role="tabpanel"
                        aria-labelledby="my_wfh_request_tab"
                    ></div>
                    {/*My WFH Request Section Ends Here*/}
                </div>
            </div>
        </>
    );
}

export default FeedbackGrid;
